export default function getDiffMinutes(date1, date2) {
  return (date2 - date1) / 60000;
}